import Vue from 'vue'
import VueMeta from 'vue-meta'
import { createInertiaApp } from '@inertiajs/vue2'
import { Link } from '@inertiajs/vue2'

Vue.config.productionTip = false
Vue.mixin({
    methods: {
        route: window.route,
    }
})
Vue.use(VueMeta);
Vue.component('inertia-link', Link);

Vue.prototype.Lang = window.Lang;

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

const getComponentName = name => require(`./Pages/${name}`).default;

createInertiaApp({
    metaInfo: {
        titleTemplate: (title) => title ? `${title} - De Leerrekening` : 'De Leerrekening Dashboard'
    },
    resolve: getComponentName,
    setup({ el, App, props, plugin }) {
        Vue.use(plugin)

        new Vue({
            render: h => h(App, props),
        }).$mount(el)
    },
});
